// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6396fa0b","455":"f83df385","977":"84a3db14"}[chunkId] + ".chunk.js";
};